/*
* Copyright  2025-2026, Airspan
* All Rights Reserved
*
* This code is unpublished, confidential and proprietary to Airspan and may only be used in accordance with the appropriate
* license agreement. All other copying, modification, distribution, or
* reverse engineering are strictly prohibited.
*/

import { createSlice } from "@reduxjs/toolkit";
import { ILabelDeviceFilterState } from "../../types";
import { initialGeoRegion } from "../../../../components/helpers";
import {
    setGeoRegionAction,
    setLabelNameAction,
    setSiteGroupAction,
    setAddDeviceGeoRegionAction,
    setAddDeviceSiteGroupAction,
    setIsAssociatedDevicesRemovedAction,
    resetFiltersAction,
    resetAddDeviceFiltersAction,
    setIsLabelDeviceAssociationProgressAction
} from "./LabelDeviceFilterActions";


const initialState: ILabelDeviceFilterState = {
    labelName: undefined,
    isLabelDeviceAssociationProgress: false,
    geoRegion: initialGeoRegion,
    addDeviceGeoRegion: initialGeoRegion,
    siteGroup: ""
};

const LabelDeviceFilterSlice = createSlice({
    name: "labelDeviceFilter",
    initialState,
    reducers: {
        setLabelName: setLabelNameAction,
        setIsLabelDeviceAssociationProgress: setIsLabelDeviceAssociationProgressAction,
        setSiteGroup: setSiteGroupAction,
        setAddDeviceSiteGroup: setAddDeviceSiteGroupAction,
        setGeoRegion: setGeoRegionAction,
        setAddDeviceGeoRegion: setAddDeviceGeoRegionAction,
        setIsAssociatedDevicesRemoved: setIsAssociatedDevicesRemovedAction,
        setResetFilters: resetFiltersAction,
        setResetAddDeviceFilters: resetAddDeviceFiltersAction,
       
    },
});

export const LabelDeviceFilterReducer = LabelDeviceFilterSlice.reducer;
export const {
    setLabelName,
    setIsLabelDeviceAssociationProgress,
    setSiteGroup,
    setAddDeviceSiteGroup,
    setGeoRegion,
    setAddDeviceGeoRegion,
    setIsAssociatedDevicesRemoved,
    setResetFilters,
    setResetAddDeviceFilters,
} = LabelDeviceFilterSlice.actions;


